import * as React from 'react'
// tslint:disable-next-line:max-line-length
import * as geCampaignType from '../../../../../typeModules/guaranteedEarningsCampaign'

import { Modal } from '@doordash/component-modal'
import { Text, StackChildren } from '@doordash/design-language'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
// tslint:disable-next-line:max-line-length
import { DX_CRO_LP_GRADUATION_Q1_2020 } from '../../../../../experimentConstants'
import { Referral } from '../../../../../models/types'
import {
  ChildrenWrapper,
  H1,
  H2,
  HeroContainer,
  Root,
  SubtitleText,
  TermsButton,
  TextContainer,
  TitleText,
} from './styles'

import { HERO_ALT_TEXT } from './constants'

import { LandingPage as Tag } from '../../../../../models/selectorAnchors'
import formatCurrency from '../../../../../utilities/formatCurrency'

import t from './strings'

const { headerTitle, headerSubtitle } = t

const getTitleFromCopy = (submarket, copy) => {
  if (submarket) {
    return copy.submarket.h1
      .replace('{submarket}', submarket.name)
      .replace('{hourly_rate}', `$${formatCurrency(submarket.hourly_rate)}`)
  }

  if (copy && copy.acquisition_test) {
    return copy.acquisition_test.h1
  }

  return headerTitle()
}

const getSubtitleFromCopy = (submarket, copy, referrer) => {
  if (submarket) {
    return copy.submarket.h2
      .replace('{submarket}', submarket.name)
      .replace('{hourly_rate}', `$${formatCurrency(submarket.hourly_rate)}`)
  }

  if (copy && copy.acquisition_test) {
    return copy.acquisition_test.h2
      .replace(
        '{referree_bonus}',
        `$${(referrer.referreeBonus / 100).toLocaleString()}`
      )
      .replace('{target_num_deliveries}', referrer.targetNumDeliveries)
      .replace(
        '{referral_expiration_in_days}',
        referrer.referralExpirationInDays
      )
  }
  return headerSubtitle()
}

const getCopyContent = (
  submarket,
  copy,
  referrer,
  guaranteedEarningsCampaign
) => {
  if (guaranteedEarningsCampaign) {
    return {
      titleContent: geCampaignType.getTitleCopy(guaranteedEarningsCampaign),
      subtitleContent: '',
    }
  }

  if (copy) {
    return {
      titleContent: getTitleFromCopy(submarket, copy),
      subtitleContent: getSubtitleFromCopy(submarket, copy, referrer),
    }
  }

  return { titleContent: '', subtitleContent: '' }
}

type HeaderProps = {
  alignChildren: 'top' | 'center' | 'bottom'
  dasherApplyPageContent: any
  referrer: Referral
  guaranteedEarningsCampaign?: any
}

export const HeaderSection: React.FC<HeaderProps> = ({
  alignChildren = 'center',
  dasherApplyPageContent,
  referrer,
  guaranteedEarningsCampaign,
  children,
}) => {
  const [displayingTermsModal, setDisplayingTermsModal] = React.useState(false)

  const toggleTermsModal = () => {
    setDisplayingTermsModal(!displayingTermsModal)
  }

  const { copy, submarket } = dasherApplyPageContent

  const { titleContent, subtitleContent } = getCopyContent(
    submarket,
    copy,
    referrer,
    guaranteedEarningsCampaign
  )

  return (
    <Root data-anchor-id={Tag.HeroRoot}>
      {displayingTermsModal && (
        <Modal title="Terms" onClose={() => toggleTermsModal}>
          <Text styles={Text.Styles.LegalText}>
            {geCampaignType.getTermsCopy(guaranteedEarningsCampaign)}
          </Text>
        </Modal>
      )}
      <TextContainer
        experiment={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q1_2020)}
      >
        <StackChildren>
          <H1>
            <TitleText
              data-anchor-id={Tag.Title}
              experiment={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q1_2020)}
            >
              {titleContent}
            </TitleText>
          </H1>
          <H2>
            <SubtitleText data-anchor-id={Tag.Subtitle}>
              {subtitleContent}
            </SubtitleText>
          </H2>
        </StackChildren>
        {guaranteedEarningsCampaign && (
          <TermsButton onClick={() => toggleTermsModal}>*See Terms</TermsButton>
        )}
      </TextContainer>
      <HeroContainer
        data-anchor-id={Tag.Hero}
        role="img"
        aria-label={HERO_ALT_TEXT}
        experiment={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q1_2020)}
      />
      <ChildrenWrapper alignChildren={alignChildren}>
        {children}
      </ChildrenWrapper>
    </Root>
  )
}

export default HeaderSection
